var map = {
	"./A-7ths.png": 32,
	"./A-Triads.png": 33,
	"./A-flat-7ths.png": 34,
	"./A-flat-Triads.png": 35,
	"./A-sharp-7ths.png": 36,
	"./A-sharp-Triads.png": 37,
	"./B-7ths.png": 38,
	"./B-Triads.png": 39,
	"./B-flat-7ths.png": 40,
	"./B-flat-Triads.png": 41,
	"./C-7ths.png": 42,
	"./C-Triads.png": 43,
	"./C-sharp-7ths.png": 44,
	"./C-sharp-Triads.png": 45,
	"./D-7ths.png": 46,
	"./D-Triads.png": 47,
	"./D-flat-7ths.png": 48,
	"./D-flat-Triads.png": 49,
	"./D-sharp-7ths.png": 50,
	"./D-sharp-Triads.png": 51,
	"./E-7ths.png": 52,
	"./E-Triads.png": 53,
	"./E-flat-7ths.png": 54,
	"./E-flat-Triads.png": 55,
	"./F-7ths.png": 56,
	"./F-Triads.png": 57,
	"./F-sharp-7ths.png": 58,
	"./F-sharp-Triads.png": 59,
	"./G-7ths.png": 60,
	"./G-Triads.png": 61,
	"./G-flat-7ths.png": 62,
	"./G-flat-Triads.png": 63,
	"./G-sharp-7ths.png": 64,
	"./G-sharp-Triads.png": 65,
	"./Numerals.png": 66,
	"./Sevenths.png": 67,
	"./Triads.png": 68,
	"./chart-stock.png": 69,
	"./modal-chart.png": 70,
	"./new-overlay.png": 10,
	"./overlay-7ths.png": 11,
	"./overlay-Triads.png": 12
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31;